import React from 'react';
import MicroUnit from '../Modular/MicroUnit';
import Unit from '../Modular/Unit';
import ServiceOffering from '../ServiceOffering/ServiceOffering';
import './Title.css';
import { useWindowSize } from '../../hooks/useWindowSize';

interface TitleProps {
  responsiveTitle: 'center' | 'left';
}

const Title = ({ responsiveTitle }: TitleProps) => {
  const windowSize = useWindowSize();
  const responsivePadding = windowSize.width <= 798 ? 'md' : '2xl';
  return (
    <Unit
      layout="flex"
      flexDirection="column"
      gap="sm"
      justifySelf={responsiveTitle}
    >
      <Unit
        background="brand-secondary"
        paddingTop="sm"
        paddingRight={responsivePadding}
        paddingLeft="xs"
        borderRadius="md"
      >
        <MicroUnit as="h1" h1Typography="title" h1Color="text-light">
          Clockhead Dev
        </MicroUnit>
        <MicroUnit as="h2" h2Typography="subtitle" h2Color="text-light">
          Building your online presence
        </MicroUnit>
      </Unit>
      <ServiceOffering></ServiceOffering>
    </Unit>
  );
};

export default Title;
